import PropTypes from 'prop-types'
import { useEffect, useId, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { I18n, Translate } from 'react-redux-i18n'
import { Checkbox } from '../../../../../../common/html/checkbox'
import { Element } from '../../../../../../common/html/element'
import { SelectCustom } from '../../../../../../common/selectCustom'
import EventEmitter, {
  SHOW_SELECT_CUSTOM,
} from '../../../../../../helpers/EventEmitter'
import { valByKeyWithDot } from '../../../../../../helpers/value'
import { filterDropList } from '../../helper'
import classes from '../../index.module.scss'
import { selectAllPortfolio } from '../../store/slice'

const DROP_DOWN_MIN_WIDTH = 200

const ItemSelectPortfolio = ({ setting, keySetting, setValue, style }) => {
  const id = useId()
  const [inputValue, setInputValue] = useState('')
  const { isChecked, selectValue } = valByKeyWithDot(setting, keySetting, true)

  const allPortfolio = useSelector(selectAllPortfolio)

  const dropList = useMemo(() => {
    return filterDropList(allPortfolio, inputValue)
  }, [inputValue])

  useEffect(() => {
    setInputValue(
      dropList.find((item) => item.value === selectValue)?.label || '',
    )
  }, [selectValue])

  const chooseItem = ({ label, value }) => {
    setValue(`setting.${keySetting}.selectValue`, value)
    setValue(`setting.${keySetting}.namePortfolio`, label)
    setInputValue(label)
  }

  const onChange = () => {
    setValue(`setting.${keySetting}.isChecked`, !isChecked)
  }

  const onClickOutside = () => {
    setInputValue(
      allPortfolio.find((item) => item.value === selectValue)?.label || '',
    )
  }

  const onClick = (e) => {
    e.stopPropagation()
    EventEmitter.dispatch(SHOW_SELECT_CUSTOM, { id })
  }

  return (
    <div
      style={{ padding: '0 20px', maxWidth: 300, ...style }}
      className={`dFlex`}
    >
      <Checkbox
        appendStyle={{ marginRight: 6 }}
        checked={isChecked}
        onChange={onChange}
        allowChange={!!selectValue}
      />
      <SelectCustom
        id={id}
        activeItem={{ value: selectValue }}
        chooseItem={chooseItem}
        data={dropList}
        style={{ backgroundColor: '#FFF' }}
        className={classes.selectCustom}
        customWidthDropdown={DROP_DOWN_MIN_WIDTH}
        handleClickOutside={onClickOutside}
        renderActiveItem={() => {
          return (
            <div className="w100 dFlex">
              <input
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                className={classes.inputCustom}
                onFocus={() => setInputValue('')}
                placeholder={I18n.t('dynamicReport.ENTER_PORTFOLIO_NAME')}
                onClick={onClick}
              />
            </div>
          )
        }}
      />
    </div>
  )
}

export default ItemSelectPortfolio

export const Title = ({ value }) => (
  <Element style={{ marginLeft: 20 }}>
    <Translate value={value} />
  </Element>
)

ItemSelectPortfolio.propTypes = {
  setting: PropTypes.object,
  keySetting: PropTypes.string,
  setValue: PropTypes.func,
  style: PropTypes.object,
}

ItemSelectPortfolio.defaultProps = {
  style: {},
}
